import { createSelector } from 'reselect';

import { initialState } from './reducers';

const selectState = (state) => state.get('AffiliationsFormPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
export const selectError = createSelector(selectState, (state) => state.get('error'));
